







































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';
import CompanySelection from '@/components/CompanySelection.vue';
import user from '@/store/modules/user';

@Component({components: {CompanySelection, Toggle}})
export default class Competition extends Vue {
  @Prop() readonly group!: any;

  company: any = null;
  competitor1: any = null;
  competitor2: any = null;

  async mounted() {
    if (dokument.Competitor1) {
      const c = await user.getCompany(dokument.Competitor1);
      if (c) {
        this.competitor1 = {
          value: c.OrgNr,
          label: c.Name,
          Branch: '   ',
        };
      }
    }
    if (dokument.Competitor2) {
      const c = await user.getCompany(dokument.Competitor2);
      if (c) {
        this.competitor2 = {
          value: c.OrgNr,
          label: c.Name,
          Branch: '   ',
        };
      }
    }
  }

  @Watch('competitor1', {immediate: false, deep: true})
  competitor1Changed() {
    if (!this.competitor1) {
      dokument.setCompetitor1('');
      this.competitor2 = null;
    } else {
      dokument.setCompetitor1(this.competitor1.value);
    }
    this.onData();
  }

  @Watch('competitor2', {immediate: false, deep: true})
  competitor2Changed() {
    if (!this.competitor2) {
      dokument.setCompetitor2('');
    } else {
      dokument.setCompetitor2(this.competitor2.value);
    }
    this.onData();
  }

  @Watch('section2', {immediate: false, deep: true})
  onData1() {
    this.onData();
  }
  @Watch('section3', {immediate: false, deep: true})
  onData2() {
    this.onData();
  }
  @Watch('section4', {immediate: false, deep: true})
  onData3() {
    this.onData();
  }
  @Watch('section5', {immediate: false, deep: true})
  onData4() {
    this.onData();
  }
  @Watch('section6', {immediate: false, deep: true})
  onData5() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get section2(): any {
    return dokument.getItems(this.group.Id)[2];
  }

  get section3(): any {
    return dokument.getItems(this.group.Id)[3];
  }

  get section4(): any {
    return dokument.getItems(this.group.Id)[4];
  }

  get section5(): any {
    return dokument.getItems(this.group.Id)[5];
  }

  get section6(): any {
    return dokument.getItems(this.group.Id)[6];
  }

  get hidden(): boolean {
    if (!this.competitor1 && !this.competitor2) {
      return true;
    }
    return this.section6.Hidden && this.section2.Hidden &&
        this.section3.Hidden && this.section4.Hidden && this.section5.Hidden;
  }
}
